export default __webpack_public_path__ + "static/media/Shonduras_BG_Web_High.1c39bcc9.jpg";